"use client";
import * as React from "react";
import { DataTable, type Column } from "../DataTable";
import { PageHeader, StatCard, Card2 } from "../ModuleHelpers";
import { useERP, formatNum } from "@/lib/erp/store";
import { HeartHandshake } from "lucide-react";

export function CRModule() {
  const erp = useERP();
  const tickets = [
    { id: "t1", code: "TKT-1001", customer: erp.customers[0].name, subject: "Invoice discrepancy in INV-2026-8824", priority: "High", status: "Open", date: "2026-10-12" },
    { id: "t2", code: "TKT-1002", customer: erp.customers[1].name, subject: "PO delivery delay - 2 days overdue", priority: "Medium", status: "In Progress", date: "2026-10-11" },
    { id: "t3", code: "TKT-1003", customer: erp.customers[2].name, subject: "Request for credit limit increase", priority: "Medium", status: "Open", date: "2026-10-10" },
    { id: "t4", code: "TKT-1004", customer: erp.customers[3].name, subject: "Wrong product delivered", priority: "High", status: "Resolved", date: "2026-10-09" },
  ];
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="CRM" desc="Customer 360, support tickets and customer experience tracking." icon={HeartHandshake} />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Total Customers" value={formatNum(erp.customers.length)} />
        <StatCard label="Open Tickets" value={formatNum(tickets.filter(t => t.status === "Open").length)} tone="text-destructive" />
        <StatCard label="Avg Resolution" value="4.2h" />
        <StatCard label="CSAT" value="92%" tone="text-primary" />
      </div>
      <Card2 title="Support Tickets">
        <DataTable
          columns={[
            { key: "code", header: "Ticket #", sortable: true, render: r => <span className="font-mono text-xs">{r.code}</span> },
            { key: "customer", header: "Customer", sortable: true },
            { key: "subject", header: "Subject" },
            { key: "date", header: "Date" },
            { key: "priority", header: "Priority", render: r => <span className={`inline-flex rounded-md px-2 py-0.5 text-xs ${r.priority === "High" ? "bg-destructive text-white" : "bg-secondary"}`}>{r.priority}</span> },
            { key: "status", header: "Status", render: r => <span className={`inline-flex rounded-md px-2 py-0.5 text-xs ${r.status === "Resolved" ? "bg-primary text-primary-foreground" : "bg-secondary"}`}>{r.status}</span> },
          ] as Column<typeof tickets[number]>[]}
          data={tickets}
          rowKey={r => r.id}
          searchKeys={["code", "customer", "subject"]}
        />
      </Card2>
    </div>
  );
}
